export const test_players = [
  {
    playerName: "Player A",
    playerIsTurn: true,
    playerIsInHand: true,
    isAtTable: true,
    playerBalance: 995,
    playerPot: 5,
    cards: [{ card: "4c" }, { card: "6d" }],
    connected: true,
    pos: 0,
  },
  {
    playerName: "Player B",
    playerIsTurn: false,
    playerIsInHand: true,
    isAtTable: true,
    playerBalance: 990,
    playerPot: 10,
    cards: null,
    connected: true,
    pos: 1,
  },
  {
    playerName: "Player C",
    playerIsTurn: false,
    playerIsInHand: true,
    isAtTable: true,
    playerBalance: 1000,
    playerPot: 0,
    cards: null,
    connected: true,
    pos: 2,
  },
  {
    playerName: "Player D",
    playerIsTurn: false,
    playerIsInHand: true,
    isAtTable: true,
    playerBalance: 1000,
    playerPot: 0,
    cards: null,
    connected: true,
    pos: 3,
  },
  {
    playerName: "Player E",
    playerIsTurn: false,
    playerIsInHand: true,
    isAtTable: true,
    playerBalance: 1000,
    playerPot: 0,
    cards: null,
    connected: true,
    pos: 4,
  },
  {
    playerName: "Player F",
    playerIsTurn: false,
    playerIsInHand: true,
    isAtTable: true,
    playerBalance: 1000,
    playerPot: 0,
    cards: null,
    connected: true,
    pos: 5,
  },
  {
    playerName: "Player G",
    playerIsTurn: false,
    playerIsInHand: true,
    isAtTable: true,
    playerBalance: 1000,
    playerPot: 0,
    cards: null,
    connected: true,
    pos: 6,
  },
  {
    playerName: "Player H",
    playerIsTurn: false,
    playerIsInHand: true,
    isAtTable: true,
    playerBalance: 1000,
    playerPot: 0,
    cards: null,
    connected: true,
    pos: 7,
  },
  {
    playerName: "Player I",
    playerIsTurn: false,
    playerIsInHand: true,
    isAtTable: true,
    playerBalance: 1000,
    playerPot: 0,
    cards: null,
    connected: true,
    pos: 8,
  },
];
